export const buildSearchText = data => {
  return `${data.seo_title} ${data.seo_description} ${data.title} ${
    data.displayName
  }
   ${data.summary} ${data.info_summary ? data.info_summary : ''} ${
    data.overview ? data.overview : ''
  }
    ${data.parent_facility} ${data.categories.join(' ')}`
}
